import { NavigationLink } from '@app/shared/interfaces/navigation-link';

export const accountnavigation: NavigationLink[] = [

    { label: 'Dashboard', url: '/account/dashboard' },

    // { label: 'Commission', url: '/account/commission' },
    { label: 'Order_History', url: '/account/orders/buy' },
    // { label: 'Sell_Order_History', url: '/account/orders/sell' },

    { label: 'Comments', url: '/account/comments' },

    { label: 'Profile', url: '/account/profile' },
    { label: 'Addresses', url: '/account/address-list' },
    { label: 'Settings', url: '/account/settings' },
    { label: 'Change_Password', url: '/account/password' },

    {
        label: 'Wallet',
        url: '/account/wallet',
        // menu: {
        //     type: 'menu',
        //     items: [
        //         { label: 'Deposit', url: '/account/deposit' },
        //         { label: 'Withdrawal', url: '/account/withdraw' }
        //     ]
        // }
    },

    { label: 'Transaction', url: '/account/transaction' },

    // { label: 'Treeview', url: '/account/treeview' },
    // { label: 'Commission_Simulation', url: '/account/commission-simulation' },
    // { label: 'Supplier', url: '/account/supplier' },
    { label: 'My_Shop', url: '/account/myshop' },

    { label: 'Notification', url: '/account/notification' },
    { label: 'Affiliate', url: '/account/affiliate' },
    // { label: 'Message', url: '/account/message' },
    //{ label: 'SignOut', url: '/account/report'},
    // { label: 'Content', url: '/account/content' },
];

